import { useShop } from "../../context/ShopContext";

export default function SortDropdown(){

const{

sort,

setSort

}=useShop();

return(

<select

value={sort}

onChange={(e)=>setSort(e.target.value)}

className="rounded-full border px-6 py-4"

>

<option>Newest</option>

<option>Price Low</option>

<option>Price High</option>

<option>Rating</option>

</select>

)

}